import { FormProvider } from "react-hook-form";

import LungReferralImage from "assets/images/lungReferralImage.png";
import ProstateReferralImage from "assets/images/prostateReferral.png";
import { FormField } from "components/form/FormField/FormField";
import { DataLoadError } from "components/ui/DataLoadError";

import { scrollToFirstError } from "../../utils/scrollToFirstError";
import { ItemFormWrapper } from "../ItemFormWrapper/ItemFormWrapper";
import { CurrentMedicationsAndConditionsFormSection } from "./components/CurrentMedicationsAndConditionsFormSection";
import { HistoryFormSection } from "./components/HistoryFormSection";
import { InvestigationsAndAttachmentsFormSection } from "./components/InvestigationsAndAttachmentsFormSection";
import { LifeStyleAndSocialHistoryFormSection } from "./components/LifeStyleAndSocialHistoryFormSection";
import { ReferralInfoFormSection } from "./components/ReferralInfoFormSection";
import { VitalSignsAndMeasurementsFormSection } from "./components/VitalSignsAndMeasurementsFormSection";
import style from "./ReferralForm.module.css";

export const ReferralForm = ({
  onBack,
  isProstateReferral,
  isLungReferral,
  onContinue,
  data,
  form,
  prefillErrors = [],
  laboratoryResults,
  radiologyResults,
  documents,
  selectedFacility,
}) => {
  const handleFormSubmit = (values) => {
    onContinue(values);
  };

  const onInvalid = (errors) => {
    console.error("Form Validation Errors:", errors);
    scrollToFirstError();
  };

  return (
    <>
      {isProstateReferral && (
        <img
          src={ProstateReferralImage}
          alt="National rapid access prostate clinic referral form"
        />
      )}
      {isLungReferral && (
        <img
          src={LungReferralImage}
          alt="National lung cancer rapid access service referral form"
        />
      )}

      <ItemFormWrapper
        onBack={onBack}
        onContinue={form.handleSubmit(handleFormSubmit, onInvalid)}
      >
        {prefillErrors.length > 0 && (
          <DataLoadError
            label={`this patient's ${prefillErrors.join(", ")}`}
            text="The matching sections below were pre-filled as empty because the data could not be loaded, not because there is nothing recorded. Check the patient record before sending this referral."
          />
        )}
        <div className={style.itemWrapper}>
          <div
            className={style.inputGroupGrid5Columns}
            style={{ marginTop: "24px" }}
          >
            <div>
              <p className={style.referralFormLabel}>Patient Name</p>
              <p className={style.referralFormValue}>
                {data.firstName} {data.familyName}
              </p>
            </div>
            <div>
              <p className={style.referralFormLabel}>Gender</p>
              <p className={style.referralFormValue}>
                {data.gender
                  ? data.gender.charAt(0).toUpperCase() +
                    data.gender.slice(1).toLowerCase()
                  : ""}
              </p>
            </div>
            <div>
              <p className={style.referralFormLabel}>Date of Birth</p>
              <p className={style.referralFormValue}>{data.dateOfBirth}</p>
            </div>
            <div>
              <p className={style.referralFormLabel}>Hospital</p>
              <p className={style.referralFormValue}>{data.hospitalName}</p>
            </div>
            <div>
              <p className={style.referralFormLabel}>Referral Type</p>
              <p className={style.referralFormValue}>
                {" "}
                {data.referralType
                  ? data.referralType.charAt(0).toUpperCase() +
                    data.referralType.slice(1).toLowerCase()
                  : ""}
              </p>
            </div>
          </div>
        </div>
        <FormProvider {...form}>
          <form
            className={style.addReferralForm}
            onSubmit={form.handleSubmit(handleFormSubmit, onInvalid)}
          >
            {!isLungReferral && (
              <ReferralInfoFormSection
                form={form}
                isProstateReferral={isProstateReferral}
                isLungReferral={isLungReferral}
              />
            )}
            <HistoryFormSection
              form={form}
              isProstateReferral={isProstateReferral}
            />
            {!isLungReferral && !isProstateReferral && (
              <VitalSignsAndMeasurementsFormSection form={form} />
            )}
            {!isLungReferral && !isProstateReferral && (
              <InvestigationsAndAttachmentsFormSection
                form={form}
                isLungReferral={isLungReferral}
                isProstateReferral={isProstateReferral}
                laboratoryResults={laboratoryResults}
                radiologyResults={radiologyResults}
                documents={documents}
                selectedFacility={selectedFacility}
              />
            )}
            <LifeStyleAndSocialHistoryFormSection
              form={form}
              isLungReferral={isLungReferral}
            />
            <CurrentMedicationsAndConditionsFormSection
              form={form}
              isLungReferral={isLungReferral}
              isProstateReferral={isProstateReferral}
            />
            <FormField name="additionalInformation">
              <label className={style.addReferralFormLabel}>
                Additional Information
              </label>
              <textarea
                className="form-control textareaform-control"
                style={{ minHeight: "126px" }}
                {...form.register("additionalInformation")}
              />
            </FormField>
            <p style={{ color: "#006546" }}>*required inputs</p>
          </form>
        </FormProvider>
      </ItemFormWrapper>
    </>
  );
};
